<template>
  <Transition name="fade">
    <div v-if="testsItem.length" class="tests-list">
      <div class="tests-item" v-for="item in testsItem" :key="item.index">
        <RouterLink
          target="_blank"
          :to="`/tests/testsdetail?clID=${item.clID}&id=${item.id}`"
          class="image"
        >
          <img v-lazy="item.testsCoverImg" alt="" />
          <p class="name ellipsis-2">{{ item.testsName }}</p>
          <div class="price">
            <span class="old-price">&yen;{{ item.grade.grPrice }}</span>
            <span class="new-price">&yen;{{ item.grade.salePrice }}</span>
          </div>
        </RouterLink>
      </div>
    </div>
    <TestItemSkeleton v-else />
  </Transition>
</template>

<script>
import TestItemSkeleton from "./test-item-skeleton.vue";
export default {
  name: "testList",
  components: {
    TestItemSkeleton,
  },
  props: {
    testsItem: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.tests-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: 7px;
  margin-top: 10px;
  width: 100%;
  //height: 610px;
  .tests-item {
    margin-right: 7px;
    margin-bottom: 10px;
    background: #efefef;
    width: 255px;
    height: 300px;
    position: relative;
    overflow: hidden;
    border: 1px solid transparent;
    transition: all 0.5s;
    &:nth-child(4n) {
      margin-right: 0px;
    }
    &:nth-last-child(-n + 4) {
      margin-bottom: 0;
    }
    .grade {
      position: absolute;
      font-weight: bold;
      top: 46.67%;
      left: 36.37%;
    }
    .grade1 {
      position: absolute;
      font-weight: bold;
      top: 46.67%;
      left: 31.37%;
    }
    .image {
      display: block;
      width: 255px;
      height: 190px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    p {
      margin: 6px 5px 10px 5px;
      height: 45px;
      font-size: 16px;
    }
    .price {
      display: flex;
      justify-content: space-around;
      .old-price {
        padding-left: 8px;
        color: @priceColor;
        font-size: 16px;
        height: 16px;
        text-decoration: line-through;
      }
      .new-price {
        margin-left: 8px;
        color: @priceColor;
        font-size: 16px;
        height: 16px;
      }
    }

    &:hover {
      border-color: @shColor;
    }
  }
}
</style>
